import { SelectionMode } from "@xyflow/react"

interface SelectionBoxStyles {
	"--xy-selection-border-default": string
	"--xy-selection-background-color-default": string
}

export const getSelectionBoxStyles = (
	selectionMode: SelectionMode,
	isSelectionActive: boolean,
): SelectionBoxStyles => {
	const baseColor = "#0059dc"
	const baseAlpha = "cc" // 80% opacity

	if (!isSelectionActive) {
		return {
			"--xy-selection-border-default": "1px solid transparent",
			"--xy-selection-background-color-default": "transparent",
		}
	}

	return {
		"--xy-selection-border-default":
			selectionMode === SelectionMode.Partial
				? `2px dashed ${baseColor}${baseAlpha}` // Partial: 2px dashed (2px line, 2px gap)
				: `1px solid ${baseColor}${baseAlpha}`, // Full: 1px solid
		"--xy-selection-background-color-default": `${baseColor}14`,
	}
}
